export default "__VITE_ASSET__C2kOhU1Z__"